import {copilot, users} from '@cl/shared';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import CLLocalStorage from 'common/src/modules/localStorage/CLLocalStorage';
import {RootState} from 'common/src/redux/store';
import {ChatState} from '../../copilot.types';
import {PersistedChatSnapshot, PersistedChatsData} from '../persistence.types';
import getCopilotChatsLSKey from './getCopilotChatsLSKey';
import convertChatToSnapshot from './typeConverters/convertChatToSnapshot';

export default function saveChatsToLocalStorage(getState: () => RootState) {
  if (
    !isFlagEnabled(FeatureFlagKey.EnableCopilotSkills) ||
    !isFlagEnabled(FeatureFlagKey.EnableCopilotMultiChat)
  ) {
    return;
  }

  const userId = users.userSubject.data?.id;

  if (!userId) {
    return;
  }

  const {chats, activeChatId} = getState().copilot;
  const snapshots = _buildSnapshots(chats);

  const data: PersistedChatsData = {activeChatId, snapshots};

  // Defer to avoid blocking the Redux dispatch that triggered this save
  setTimeout(() => {
    CLLocalStorage.setStringified(getCopilotChatsLSKey(userId), data);
  }, 0);
}

function _buildSnapshots(chats: ChatState[]): PersistedChatSnapshot[] {
  const runtimeChats = copilot.allChats.current;

  return chats.flatMap((reduxChat) => {
    const runtimeChat = runtimeChats.find((chat) => chat.id === reduxChat.id);

    if (!runtimeChat) {
      return [];
    }

    try {
      return [convertChatToSnapshot(reduxChat, runtimeChat)];
    } catch {
      return [];
    }
  });
}
